import { useState } from 'react';

import {
  allocationSharesColDef,
  allocationUsdColDef,
  aumColDef,
  indicationSharesColDef,
  indicationUsdColDef,
  investorNameColDef,
  investorTypeColDef,
  isRoadshowParticipationColDef,
  lastUpdatedByColDef,
  lastUpdatedTimeColDef,
  linkedCMGEntityKeyColDef,
  linkedCMGEntityNameColDef,
  linkStatusColDef,
} from '../column-definitions';
import { ParticipationGridColDef } from '../types';

export const useCreateColumnDefs = () => {
  const [colDefs] = useState<ParticipationGridColDef[]>([
    investorNameColDef,
    allocationSharesColDef,
    allocationUsdColDef,
    indicationSharesColDef,
    indicationUsdColDef,
    investorTypeColDef,
    aumColDef,
    isRoadshowParticipationColDef,
    linkStatusColDef,
    linkedCMGEntityNameColDef,
    linkedCMGEntityKeyColDef,
    lastUpdatedTimeColDef,
    lastUpdatedByColDef,
  ]);

  return colDefs;
};
